import React from 'react'

// Splits `copy` on each marker in `replacements` (applied in order) and
// splices in the paired node at that position — the shared building block
// behind every "cheap rich-text" sentence in this scene: a link or bolded
// fragment spliced into otherwise-plain translated copy (OloWebhookModal's
// `withInline` is the single-marker case of this). Fails loudly rather than
// silently dropping a fragment: a locale edit that drops or duplicates a
// marker throws instead of silently rendering a truncated sentence.
export const withMarkers = (
  copy: string,
  replacements: [marker: string, node: React.ReactNode][]
): React.ReactNode => {
  if (replacements.length === 0) return copy

  const [[marker, node], ...rest] = replacements
  const parts = copy.split(marker)
  if (parts.length !== 2) {
    throw new Error(
      `withMarkers: expected exactly one "${marker}" in "${copy}"`
    )
  }
  const [before, after] = parts
  return (
    <>
      {before}
      {node}
      {withMarkers(after, rest)}
    </>
  )
}
